var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7701 0C13.0253 0 14.2122 0.571532 14.9949 1.55284L18.3498 5.75906C18.9326 6.48972 19.25 7.39662 19.25 8.33123V17.875C19.25 20.1532 17.4032 22 15.125 22H4.125C1.84683 22 0 20.1532 0 17.875V4.125C0 1.84683 1.84683 0 4.125 0H11.7701ZM13.8566 7.79842C12.6374 6.57926 10.709 6.45585 9.34837 7.49002C9.04608 7.71978 8.98728 8.15109 9.21704 8.45338C9.44681 8.75567 9.87812 8.81446 10.1804 8.5847C10.9954 7.96527 12.153 8.03935 12.8843 8.77069C13.6898 9.57614 13.6898 10.882 12.8843 11.6875L10.4608 14.1172L9.28147 15.2903L9.19315 15.3737C8.3819 16.0962 7.13987 16.0685 6.36318 15.2918C5.58649 14.5151 5.55875 13.2731 6.27996 12.4632L6.30867 12.4317L6.36627 12.3813L7.9392 10.8084L7.99916 10.755C8.26902 10.5413 8.66216 10.5591 8.91147 10.8084C9.17995 11.0769 9.17995 11.5122 8.91147 11.7807L7.35666 13.3355L7.30324 13.3954C7.08955 13.6653 7.10736 14.0584 7.35666 14.3078C7.62515 14.5762 8.06045 14.5762 8.32894 14.3078L9.88374 12.7529L9.96696 12.6648C10.6882 11.8549 10.6604 10.6128 9.88374 9.83613C9.07828 9.03068 7.77238 9.03068 6.96692 9.83613L6.36679 10.4366L6.30697 10.4902L5.87257 10.9243L5.39301 11.4006C4.04849 12.7452 4.04848 14.9217 5.39091 16.2641C6.73334 17.6065 8.90984 17.6065 10.2523 16.2641L11.842 14.684L11.8851 14.6354L13.8566 12.6598L13.9598 12.5521C15.1981 11.2034 15.1637 9.10551 13.8566 7.79842Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIconEmail);
export default __webpack_public_path__ + "static/media/attachmentIconEmail.43669a81a87ca8dbdab78e046705ac28.svg";
export { ForwardRef as ReactComponent };